import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ToggleService {
    private toggleState: { [key: string]: boolean } = {};
    private readonly toggleState$ = new BehaviorSubject<{
        [key: string]: boolean;
    }>({});

    /** Emits the full toggle-state map whenever any toggle changes. Lets
     *  separate components that each own a toggle (e.g. the header profile menu
     *  and the notifications dropdown) stay mutually exclusive: because
     *  onToggleClicked clears every other key, subscribers can close themselves
     *  when another toggle opens. */
    public readonly changes$: Observable<{ [key: string]: boolean }> =
        this.toggleState$.asObservable();

    public setAllToggleStateToFalse(): void {
        for (const key in this.toggleState) {
            this.toggleState[key] = false;
        }
        this.emit();
    }

    public setToggleState(key: string, value: boolean): void {
        this.toggleState[key] = value;
        this.emit();
    }

    public getToggleState(key: string): boolean {
        return this.toggleState[key];
    }

    public onToggleClicked(type: string, toggleState: boolean): boolean {
        this.setAllToggleStateToFalse();
        this.setToggleState(type, toggleState);
        return this.getToggleState(type);
    }

    private emit(): void {
        this.toggleState$.next({ ...this.toggleState });
    }
}
